export default "__VITE_ASSET__BkcmJDps__"